
import { cls } from 'tagged-classnames-free';
import { useMemo } from 'react';
import Link from '@/components/Link';
interface IPaginationProps {
  /** 当前页码 */
  current?: number
  /** 当前页数据大小 */
  size?: number
  /** 数据总量 */
  total?: number
  /** 只有一页时是否隐藏分页器，默认 false */
  hideOnSinglePage?: boolean
  getHref?: (page: number) => string | void
  itemClassName?: string
  activeClassName?: string
}

export default function HubPagination(props: IPaginationProps) {
  const {
    current,
    size = 0,
    total = 0,
    hideOnSinglePage,
    itemClassName = cls`hover:text-f-primary hover:bg-f-bg-layout`,
    activeClassName = cls`text-f-primary bg-f-bg-layout`,
    getHref,
  } = props
  const pageTotal = useMemo(() => {
    if (total && size) {
      return Math.ceil(total / size)
    }
    return 0
  }, [size, total])

  if (!current || !size || !total || (hideOnSinglePage && pageTotal === 1)) {
    return null
  }

  const itemClass = cls`
    flex h-6 w-8 items-center justify-center rounded
    text-xs 
    ${itemClassName}
  `
  return (
    <ul className='mx-auto flex w-fit flex-wrap items-center justify-center gap-[10px] pt-8'>
      {current > 1 && (
        <li>
          <Link href={getHref?.(current - 1) || '#'} className={`${itemClass}`}>
            <span className='i-com--left size-5' />
          </Link>
        </li>
      )}
      {Array.from({ length: pageTotal })
        .fill(null)
        .map((_, index) => {
          const page = index + 1
          return (
            <li key={index}>
              <Link
                className={cls`
                  ${itemClass}
                  ${current === page ? activeClassName : ''}
                `}
                href={getHref?.(page) || '#'}
              >
                {page}
              </Link>
            </li>
          )
        })}
      {current < pageTotal && (
        <li>
          <Link href={getHref?.(current + 1) || '#'} className={`${itemClass}`}>
            <span className='i-com--right size-5' />
          </Link>
        </li>
      )}
    </ul>
  )
}
